import i18n from '@/i18n';
import { inspectionPackages } from '@/utils/permission';
const Layout = () => import('@/layouts/main.vue');
const InspectionPackages = () => import('./views/Index.vue');
const InspectionPackageView = () => import('./views/InspectionPackageView.vue');

export default [
  {
    path: 'inspection-packages',
    component: Layout,
    meta: { authRequired: true, header: true },
    children: [
      {
        path: '',
        name: 'InspectionPackages',
        component: InspectionPackages,
        meta: {
          title: i18n.global.t('inspectionPackages.inspectionPackages'),
          permission: { module: inspectionPackages.module, key: inspectionPackages.showAll },
        },
      },
      {
        path: 'view/:id?',
        name: 'InspectionPackages.View',
        component: InspectionPackageView,
        meta: {
          title: i18n.global.t('inspectionPackages.view'),
          pageType: 'view',
          permission: { module: inspectionPackages.module, key: inspectionPackages.showOne },
        },
        props: true,
      },
      {
        path: 'create',
        name: 'InspectionPackages.Create',
        component: InspectionPackageView,
        meta: {
          title: i18n.global.t('inspectionPackages.create'),
          pageType: 'create',
          permission: { module: inspectionPackages.module, key: inspectionPackages.create },
        },
      },
      {
        path: 'update/:id?',
        name: 'InspectionPackages.Update',
        meta: {
          title: i18n.global.t('inspectionPackages.update'),
          pageType: 'update',
          permission: { module: inspectionPackages.module, key: inspectionPackages.update },
        },
        component: InspectionPackageView,
        props: true,
      },
    ],
  },
];
